import { styled } from "styled-components";
import { useState } from "react";

const FilterButton = styled.button<{ active?: boolean }>`
  padding: 0.5rem 1rem;
  border: 2px solid var(--primary);
  border-radius: 4px;
  background-color: ${props => props.active ? 'var(--primary)' : 'transparent'};
  color: ${props => props.active ? 'white' : 'var(--primary)'};
  font-weight: bold;
  
  &:hover {
    background-color: var(--primary);
    color: white;
  }
`;

const FilterSection = styled.div`
  margin-bottom: 2rem;
  display: flex;
  gap: 1rem;
`;

const GameFilter = () => {
    const [filter, setFilter] = useState<'all' | 'home' | 'away'>('all');

    return (
        <FilterSection>
            <FilterButton
                active={filter === 'all'}
                onClick={() => setFilter('all')}
            >
                All Results
            </FilterButton>
            <FilterButton
                active={filter === 'home'}
                onClick={() => setFilter('home')}
            >
                Home
            </FilterButton>
            <FilterButton
                active={filter === 'away'}
                onClick={() => setFilter('away')}
            >
                Away
            </FilterButton>
        </FilterSection>)
}

export default GameFilter;